import React from 'react';
import { getSrc } from 'gatsby-plugin-image';
import bgPattern from '../../images/header-bg-pattern.png';

export default function Header({
  title,
  tagline,
  image,
  backgroundOverlay,
  backgroundOverlayOpacity,
}) {
  const overlayClass = `overlay-${backgroundOverlay}`;
  const opacityClass = `overlay-opacity-${backgroundOverlayOpacity}`;
  const imageClass = image ? 'with-image' : '';
  const style = image
    ? { backgroundImage: `url('${getSrc(image)}')` }
    : { backgroundImage: `url('${bgPattern}')` };
  const overlayNode = backgroundOverlay !== 'None' ? <div className="overlay"></div> : '';
  const mytitle = title ? <h1 className="title">{title}</h1> : '';
  const subtitle = tagline ? <div className="tagline">{tagline}</div> : '';

  return (
    <section
      className={`heading-section overlay ${overlayClass} ${opacityClass} ${imageClass}`}
      style={style}
    >
      {overlayNode}
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="page-title-wrapper">
            {mytitle}
            {subtitle}
          </div>
        </div>
      </div>
    </section>
  );
}
